<template>
  <div class="mt-tool">
    <!-- Questions -->
    <div class="mt-form" v-if="!result">
      <div class="mt-head">
        <h3 class="mt-title">{{ $t('tool.MbtiTest.title') }}</h3>
        <p class="mt-sub">{{ $t('tool.MbtiTest.subtitle') }}</p>
        <div class="mt-progress">
          <div class="mt-progress-bar" :style="{width:answeredCount/questions.length*100+'%'}"></div>
        </div>
        <span class="mt-progress-text">{{ answeredCount }} / {{ questions.length }}</span>
      </div>

      <div class="mt-q" v-for="(q, qi) in questions" :key="qi">
        <p class="mt-q-num">{{ qi + 1 }}</p>
        <p class="mt-q-text">{{ q.text }}</p>
        <div class="mt-opts">
          <div
            v-for="(opt, oi) in q.options"
            :key="oi"
            :class="['mt-opt', { active: answers[qi] === oi }]"
            @click="answers[qi] = oi; $set(answers, qi, oi)"
          >
            <span class="mt-opt-mark">{{ oi === 0 ? 'A' : 'B' }}</span>
            <span class="mt-opt-text">{{ opt }}</span>
          </div>
        </div>
      </div>

      <el-button type="primary" :disabled="!allAnswered" @click="calcResult" size="medium" class="mt-submit">
        {{ $t('tool.MbtiTest.viewResult') }}
      </el-button>
    </div>

    <!-- Result -->
    <div class="mt-result" v-else>
      <div class="mt-r-card">
        <div class="mt-r-type-wrap">
          <div class="mt-r-type-row">
            <span v-for="c in result.type" :key="c" class="mt-r-letter">{{ c }}</span>
          </div>
          <span class="mt-r-name">{{ result.name }}</span>
        </div>

        <p class="mt-r-desc">{{ result.desc }}</p>

        <div class="mt-r-dims">
          <div class="mt-r-dim" v-for="d in result.dims" :key="d.key">
            <span class="mt-r-dim-l">{{ d.leftLabel }}</span>
            <div class="mt-r-dim-track">
              <div class="mt-r-dim-bar">
                <div class="mt-r-dim-fill" :style="{width:d.pct+'%',background:d.left?'#4e7cff':'#e6a23c'}"></div>
              </div>
            </div>
            <span class="mt-r-dim-r">{{ d.rightLabel }}</span>
          </div>
        </div>

        <el-button size="small" plain class="mt-retry" @click="reset">{{ $t('tool.MbtiTest.restart') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
var Q_DIMS = [
  {dim:'EI',e:1,i:0},{dim:'TF',t:1,f:0},{dim:'SN',s:1,n:0},{dim:'JP',j:1,p:0},
  {dim:'SN',s:1,n:0},{dim:'TF',t:1,f:0},{dim:'EI',e:1,i:0},{dim:'JP',j:0,p:1},
  {dim:'TF',t:1,f:0},{dim:'SN',s:1,n:0},{dim:'EI',e:1,i:0},{dim:'JP',j:1,p:0}
]

export default {
  name: 'MbtiTestTool',
  props: { config: { type: Object, default: function() { return {} } } },
  data() {
    return { answers: new Array(12).fill(null), result: null }
  },
  computed: {
    questions: function() {
      var t = this, qs = this.$t('tool.MbtiTest.questions')
      return qs.map(function(q, i) {
        var d = Q_DIMS[i]
        return { text: q.text, options: [q.a, q.b], dim: d.dim, e: d.e, i: d.i, t: d.t, f: d.f, s: d.s, n: d.n, j: d.j, p: d.p }
      })
    },
    allAnswered() { return this.answers.every(function(a) { return a !== null }) },
    answeredCount() { return this.answers.filter(function(a) { return a !== null }).length }
  },
  methods: {
    calcResult() {
      var scores = { E:0, I:0, S:0, N:0, T:0, F:0, J:0, P:0 };
      for (var i = 0; i < this.questions.length; i++) {
        var q = this.questions[i], a = this.answers[i];
        a === 0 ? scores[q.dim[0]]++ : scores[q.dim[1]]++;
      }
      var type = (scores.E > scores.I ? 'E' : 'I') + (scores.S > scores.N ? 'S' : 'N') + (scores.T > scores.F ? 'T' : 'F') + (scores.J > scores.P ? 'J' : 'P');
      var info = this.$t('tool.MbtiTest.types')[type];
      var dl = this.$t('tool.MbtiTest')
      var dims = [
        { key:'EI', leftLabel:dl.dimE, rightLabel:dl.dimI, left:scores.E>scores.I, pct:Math.round(Math.max(scores.E,scores.I)/6*100) },
        { key:'SN', leftLabel:dl.dimS, rightLabel:dl.dimN, left:scores.S>scores.N, pct:Math.round(Math.max(scores.S,scores.N)/6*100) },
        { key:'TF', leftLabel:dl.dimT, rightLabel:dl.dimF, left:scores.T>scores.F, pct:Math.round(Math.max(scores.T,scores.F)/6*100) },
        { key:'JP', leftLabel:dl.dimJ, rightLabel:dl.dimP, left:scores.J>scores.P, pct:Math.round(Math.max(scores.J,scores.P)/6*100) }
      ];
      this.result = { type: type, name: info.name, desc: info.desc, dims: dims };
    },
    reset() { this.result = null; this.answers = new Array(12).fill(null) },
    doAction(a) { if (a === 'clear') this.reset() }
  }
}
</script>

<style scoped>
.mt-tool { width: 100%; }

/* ---- 题目页 ---- */
.mt-head { text-align: center; margin-bottom: 32px; }
.mt-title { font-size: 26px; font-weight: 800; color: #1a1f36; margin: 0 0 6px; }
.mt-sub { font-size: 14px; color: #8892a6; margin: 0 0 20px; }
.mt-progress { height: 4px; background: #eef0f4; border-radius: 2px; overflow: hidden; margin-bottom: 8px; }
.mt-progress-bar { height: 100%; background: linear-gradient(90deg, #4e7cff, #6b3cf0); border-radius: 2px; transition: width .4s ease; }
.mt-progress-text { font-size: 12px; color: #b0b8c4; }

.mt-q { margin-bottom: 20px; }
.mt-q-num {
  width: 24px; height: 24px; border-radius: 50%;
  background: #4e7cff; color: #fff; font-size: 12px; font-weight: 700;
  display: inline-flex; align-items: center; justify-content: center; margin-bottom: 8px;
}
.mt-q-text { margin: 0 0 10px; font-size: 15px; color: #1a1f36; font-weight: 600; }

.mt-opts { display: flex; flex-direction: column; gap: 8px; }
.mt-opt {
  display: flex; align-items: center; gap: 12px;
  padding: 14px 16px; border-radius: 10px; border: 2px solid #e8ebf0;
  cursor: pointer; transition: all .2s;
}
.mt-opt:hover { border-color: #c8cfe0; background: #f8f9fc; }
.mt-opt.active { border-color: #4e7cff; background: #f0f4ff; }
.mt-opt-mark {
  width: 28px; height: 28px; border-radius: 50%;
  background: #f0f2f5; color: #8892a6; font-size: 12px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  transition: all .2s;
}
.mt-opt.active .mt-opt-mark { background: #4e7cff; color: #fff; }
.mt-opt-text { font-size: 14px; color: #4a5568; line-height: 1.5; }

.mt-submit { width: 100%; margin-top: 32px; height: 48px; font-size: 16px; border-radius: 10px; }

/* ---- 结果页 ---- */
.mt-r-card {
  background: #fff; border-radius: 16px; border: 1px solid #ebeef5;
  padding: 40px 32px 32px; text-align: center;
}
.mt-r-type-wrap { margin-bottom: 20px; }
.mt-r-type-row { display: flex; justify-content: center; gap: 8px; margin-bottom: 10px; }
.mt-r-letter {
  width: 56px; height: 64px; border-radius: 12px;
  background: linear-gradient(135deg, #4e7cff, #6b3cf0);
  color: #fff; font-size: 28px; font-weight: 800;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 16px rgba(78,124,255,0.25);
}
.mt-r-name { font-size: 20px; color: #4e7cff; font-weight: 700; }

.mt-r-desc { font-size: 14px; color: #606266; line-height: 2; max-width: 420px; margin: 0 auto 28px; }

.mt-r-dims { display: flex; flex-direction: column; gap: 16px; margin-bottom: 28px; }
.mt-r-dim { display: flex; align-items: center; gap: 10px; }
.mt-r-dim-l, .mt-r-dim-r { font-size: 12px; color: #8892a6; white-space: nowrap; min-width: 52px; }
.mt-r-dim-l { text-align: right; }
.mt-r-dim-r { text-align: left; }
.mt-r-dim-track { flex: 1; }
.mt-r-dim-bar { height: 8px; background: #eef0f4; border-radius: 4px; overflow: hidden; }
.mt-r-dim-fill { height: 100%; border-radius: 4px; transition: width .6s ease; }

.mt-retry { width: 100%; height: 40px; border-radius: 8px; }

@media (max-width: 480px) {
  .mt-r-letter { width: 44px; height: 52px; font-size: 22px; }
  .mt-r-card { padding: 28px 20px 24px; }
}
</style>
